var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Experiences',{attrs:{"customFetch":_vm.app.customFetch,"survey_id":_vm.app.survey.id,"surveyType":_vm.app.surveyType}})}
var staticRenderFns = []

export { render, staticRenderFns }